var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1080,
    height: 904,
    viewBox: "0 0 1080 904",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -11.8881,
    y: -299.5,
    width: 1103.78,
    height: 1215
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(6px)",
      clipPath: "url(#bgblur_0_172_3426_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 12,
    d: "M822.514 903H257.983C254.877 903 253.324 903 252.223 902.108C251.122 901.215 250.8 899.696 250.157 896.657L1.54515 -277.343C0.600075 -281.805 0.127537 -284.037 1.32819 -285.518C2.52885 -287 4.80979 -287 9.37165 -287H1070.63C1075.19 -287 1077.47 -287 1078.67 -285.519C1079.87 -284.038 1079.4 -281.807 1078.46 -277.346L830.341 896.654C829.699 899.694 829.377 901.214 828.276 902.107C827.175 903 825.621 903 822.514 903Z",
    fill: "url(#paint0_linear_172_3426)",
    fillOpacity: 0.08,
    stroke: "url(#paint1_linear_172_3426)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_172_3426_clip_path",
    transform: "translate(11.8881 299.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M822.514 903H257.983C254.877 903 253.324 903 252.223 902.108C251.122 901.215 250.8 899.696 250.157 896.657L1.54515 -277.343C0.600075 -281.805 0.127537 -284.037 1.32819 -285.518C2.52885 -287 4.80979 -287 9.37165 -287H1070.63C1075.19 -287 1077.47 -287 1078.67 -285.519C1079.87 -284.038 1079.4 -281.807 1078.46 -277.346L830.341 896.654C829.699 899.694 829.377 901.214 828.276 902.107C827.175 903 825.621 903 822.514 903Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_172_3426",
    x1: 534,
    y1: 77.1359,
    x2: 534,
    y2: 903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A164FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#A164FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_172_3426",
    x1: 534,
    y1: 77.1359,
    x2: 534,
    y2: 903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDE0FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDE0FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLight);
export default __webpack_public_path__ + "static/media/light.10d2fa13fc19fa4b38c639da219f9f04.svg";
export { ForwardRef as ReactComponent };